module.exports = __webpack_public_path__ + "static/media/E104A882-CC95-4A2F-94E2-A74A197BFAFC.59f57fb4.jpeg";